var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoungeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 76,
    viewBox: "0 0 79 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9483 57.5906V76H54.1611V59.6577H30.8661V76H25.0789V59.6577H11.5748V76H5.78692V50.5827C5.73037 49.1301 6.29186 47.7205 7.33338 46.7026C8.3749 45.6848 9.79955 45.1527 11.2564 45.2379H25.0788V29.8572H0V26.9158C0 17.2998 5.14762 8.41358 13.5041 3.60597C21.8604 -1.20199 32.1559 -1.20199 40.5133 3.60597C48.8695 8.41392 54.0173 17.3 54.0173 26.9158V29.8572H30.8671V45.2379H59.9014L62.1197 40.6043L37.8027 40.5466V34.7792L65.0618 34.6061L73.82 17.1482L79 19.7247L59.9483 57.5906Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeOrange);
export default __webpack_public_path__ + "static/media/lounge_Orange.efe454960151d24d448887dea5aae6db.svg";
export { ForwardRef as ReactComponent };